
export default {
    middleware: 'isSubscribe',
    data () {
        return {
            form: new this.$vForm({
                filters: this.getFiltersFromUrl(),
                orderBy: this.$route.query.orderBy ?? 'desc',
                page: this.$route.query.page ? parseInt(this.$route.query.page) : 1
            }),
            hxn: [],
            links: [],
            cancelToken: null,
            loading: false,
            highlightsColors: {
                redHighlight: {
                    class: 'bg-red-400',
                    selectedClass: 'bg-red-100'
                },
                yellowHighlight: {
                    class: 'bg-yellow-400',
                    selectedClass: 'bg-yellow-100'
                },
                blueHighlight: {
                    class: 'bg-blue-400',
                    selectedClass: 'bg-blue-100'
                },
                greenHighlight: {
                    class: 'bg-green-400',
                    selectedClass: 'bg-green-100'
                },
                purbleHighlight: {
                    class: 'bg-purple-400',
                    selectedClass: 'bg-purple-100'
                },
                note: {
                    class: 'bg-slate-400',
                    selectedClass: 'bg-slate-100'
                }
            }
        }
    },
    watch: {
        'form.orderBy' (val) {
            this.form.page = 1
            this.updateQueryString()
        },
        'form.filters' () {
            this.form.page = 1
            this.updateQueryString()
        },
        'form.page' () {
            this.updateQueryString()
        }
    },
    mounted () {
        this.loadHxN()
    },
    methods: {
        async loadHxN () {
            if (this.cancelToken !== null) {
                this.cancelToken.cancel('Operation canceled due to new request.')
            }
            this.cancelToken = this.$axios.CancelToken.source()
            this.loading = true
            try {
                const { data } = await this.form.get(this.localePath('/v1/highlights'), { params: this.form.data(), cancelToken: this.cancelToken.token })
                this.hxn = data.data
                this.links = data.meta.links
                this.loading = false
            } catch (err) {
                if (!this.$axios.isCancel(err)) {
                    throw err
                }
            }
        },
        updateQueryString () {
            this.$router.push({
                query: {
                    filters: this.form.filters,
                    orderBy: this.form.orderBy,
                    page: this.form.page
                }
            })
            this.loadHxN()
        },
        removeItem (id) {
            this.hxn = this.hxn.filter(hxn => hxn.id !== id)
        },
        getFiltersFromUrl () {
            if (!this.$route.query.filters) {
                return []
            }
            const filters = Array.isArray(this.$route.query.filters) ? this.$route.query.filters : [this.$route.query.filters]

            return filters.filter(f => [
                'redHighlight',
                'yellowHighlight',
                'blueHighlight',
                'greenHighlight',
                'purbleHighlight',
                'note'
            ].includes(f))
        }
    },
    head: {
        title: 'تحديداتي وملاحظاتي'
    }
}
